import { render, staticRenderFns } from "./NeedToTurnNew.vue?vue&type=template&id=152853e0&"
import script from "./NeedToTurnNew.vue?vue&type=script&lang=js&"
export * from "./NeedToTurnNew.vue?vue&type=script&lang=js&"
import style0 from "./NeedToTurnNew.vue?vue&type=style&index=0&id=152853e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports